import { Component, Inject, EventEmitter, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { FILE_ERROR_MESSAGES } from '../../core/constants';
import { Certificate } from '../../models/certificate.model';
import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'app-auth-modal',
    templateUrl: './auth-modal.component.html',
    styleUrls: ['./auth-modal.component.css'],
    standalone: false
})
export class AuthModalComponent {
  nuip: string = '';
  password: string = '';
  passwordVisible: boolean = false;
  isLoading: boolean = false;
  isAuthenticated: boolean = false;
  selectedCertificate: Certificate | null = null;
  @Output() credentialsEntered = new EventEmitter<{ nuip: string; password: string }>();

  constructor(
    public dialogRef: MatDialogRef<AuthModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { certificates: Certificate[] },
    private notificationService: NotificationService
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  submitCredentials(): void {
    if (!this.nuip || !this.password) {
      Swal.fire({
        ...this.notificationService.getSwalBaseConfig(),
        icon: 'error',
        title: 'Campos obligatorios',
        text: FILE_ERROR_MESSAGES.MISSING_CREDENTIALS,
        confirmButtonText: 'Entendido',
        customClass: {
          popup: 'custom-swal-popup',
          title: 'custom-swal-title',
          confirmButton: 'custom-swal-button'
        }
      });
      return;
    }
    
    this.isLoading = true;
    this.credentialsEntered.emit({ nuip: this.nuip, password: this.password });
  }

  selectCertificate(cert: Certificate): void {
    this.selectedCertificate = cert;
  }

  confirmSelection(): void {
    if (this.selectedCertificate) {
      this.dialogRef.close({ selectedCertificate: this.selectedCertificate });
    }
  }

  goBack(): void {
    this.isAuthenticated = false;
    this.selectedCertificate = null;
    this.nuip = '';
    this.password = '';
    this.passwordVisible = false;
  }

}